const baseVehicleFromDto = (dto) => ({
  fasecoldaCode: dto.codigo_fasecolda,
  brand: dto.marca,
  line: dto.referencia,
  class: dto.clase,
});

const plateFromDto = (dto) => ({
  plate: dto.placa,
});

const modelFromDto = (dto) => ({
  model: dto.modelo,
});

const insuredValueFromDto = (dto) => ({
  insuredValue: dto.valor_asegurado,
});

export const vehicleFromDto = (dto) => ({
  ...baseVehicleFromDto(dto),
  ...plateFromDto(dto),
  ...modelFromDto(dto),
  ...insuredValueFromDto(dto),
  id: dto.id,
  accessoriesValue: dto.valor_accesorios,
  circulationCityId: dto.ciudad_circulacion,
  circulationCityName: dto.ciudad_circulacion_name,
  service: dto.servicio,
  isUtilitarian: dto.is_utilitarian,
  isNew: dto.is_new,
  hasPlate: dto.has_plate,
});

export const vehicleByPlateFromDto = (dto) => ({
  ...baseVehicleFromDto(dto),
  ...plateFromDto(dto),
  ...modelFromDto(dto),
  ...insuredValueFromDto(dto),
  engine: dto.motor,
  chassis: dto.chasis,
});

export const vehicleByFasecoldaFromDto = (dto) => ({
  ...baseVehicleFromDto(dto),
  modelValues: dto.valores_modelo.map((modelValueDto) => ({
    ...modelFromDto(modelValueDto),
    ...insuredValueFromDto(modelValueDto),
  })),
});

export const vehicleByBrandModelLineFromDto = (dto) => ({
  ...baseVehicleFromDto(dto),
  ...modelFromDto(dto),
  ...insuredValueFromDto(dto),
});

export const vehicleToDto = (data) => ({
  placa: data.plate,
  codigo_fasecolda: data.fasecoldaCode,
  modelo: data.model,
  marca: data.brand,
  referencia: data.line,
  clase: data.class,
  motor: data.engine,
  chasis: data.chassis,
  valor_asegurado: data.insuredValue,
  valor_accesorios: data.accessoriesValue,
  ciudad_circulacion: data.circulationCityId,
  servicio: data.service,
  is_utilitarian: data.isUtilitarian,
  is_new: data.isNew,
  has_plate: data.hasPlate,
})

export const brandWithModelsFromDto = (dto) => ({
  brand: dto.marca,
  models: dto.modelos,
});

export const lineDetailsFromDto = (dto) => ({
  line: dto.referencia,
  line1: dto.referencia1,
  line2: dto.referencia2,
  line3: dto.referencia3,
});

export const categoryFromVehicleDataDto = (dto) => ({
  id: dto.id,
  name: dto.nombre,
});

export const modelFromVehicleDataDto = (dto) => ({
  id: dto.id,
  name: String(dto.nombre),
});

export const brandFromVehicleDataDto = (dto) => ({
  id: dto.id,
  name: dto.nombre,
});

export const vehicleInfoFromDto = (dto) => ({
  fasecoldaCode: dto.homoloCodigo,
  brand: dto.marca,
  line: dto.linea,
  class: dto.clase,
  category: dto.categoria,
  service: dto.servicio,
  modelValues: dto.valorModelo?.map((mv) => ({
    model: String(mv.modelo),
    modelId: mv.modeloId,
    insuredValue: mv.valor * 1000,
    isNew: mv.estado === 'NUEVO',
  })) ?? [],
});